import {ErrorBoundary} from "react-error-boundary";
import ScrollToTop from "./components/ScrollToTop.tsx";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import LandingPage from "./pages/home";
import "./styles/tailwind.css";
import "./styles/index.css";

function App() {
    return (
        <BrowserRouter>
            <ErrorBoundary fallback={<div>Something went wrong</div>}>
                <ScrollToTop/>
                <Routes>
                    <Route path="/" element={<LandingPage/>}/>
                </Routes>
            </ErrorBoundary>
        </BrowserRouter>
    );
}

export default App;
